export { EScreenType } from '@naviair-utm/node-shared-interfaces';
